import { useEffect, useState } from 'react';
import { Button, Form, message, Input, Modal, Select, DatePicker } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { DEVICE_OPTIONS } from './GenerateNewIdModal.constants';
import { api } from '@/shared/api/api';
import { fetchListUsersTable } from './api/fetchListUsersTable.api';

const GenerateNewIdModal = params => {
  const {
    fetchListDevices,
    actualSegment,
    userInfo,
    isGenerateIdOpen,
    setGenerateIdOpen,
    searchValue,
    setSearchValue,
    ref,
  } = params;
  const [value, setValue] = useState([]);
  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);
  const [data, setData] = useState([]);

  dayjs.extend(utc);

  useEffect(() => {
    form.setFieldsValue({ device_id: searchValue });
  }, [form, isGenerateIdOpen, searchValue]);

  const fetchUserData = async () => {
    const userData = await fetchListUsersTable(userInfo.userId);
    setData(userData);
  };

  const currentDate = dayjs.utc().minute(0).second(0).millisecond(0);
  const nextYearDate = dayjs(currentDate).add(180, 'days');

  const showModal = () => {
    setGenerateIdOpen(true);
  };

  const handleCancel = () => {
    setGenerateIdOpen(false);
    setSearchValue('');
    form.resetFields();
  };

  const checkFormValidity = () => {
    const values = form.getFieldsValue();
    const requiredFieldsFilled = values.device_id && values.call_sign && values.army_post && values.type;
    setIsFormValid(requiredFieldsFilled);
  };

  const onFinish = async values => {
    try {
      const license_expires = values.license_expires.minute(0).second(0).millisecond(0);
      await api.post(`/api/device`, {
        user_id: userInfo.userId,
        device_id: values.device_id,
        call_sign: values.call_sign,
        army_post: values.army_post,
        type: values.type.value,
        sub_id: values.sub_id ? values.sub_id.value : null,
        tg: values.tg || null,
        serial: values.serial || null,
        license_expires: license_expires,
      });

      message.success('Устройство успешно добавлено!');

      fetchListDevices(actualSegment);
      setGenerateIdOpen(false);
    } catch (error) {
      console.log(error);
      console.error('ERROR - onGenerateNewIdModal - forwarder>>>', error);

      if (error.response.status === 404) {
        message.error('ОШИБКА создания! Указанная серия не найдена');
      } else if (error.response.status === 409) {
        message.error('ОШИБКА создания! Устройство с таким ID уже существует');
      } else {
        message.error('ОШИБКА создания!');
      }
    }
  };

  const handleOk = () => {
    form
      .validateFields()
      .then(values => {
        form.resetFields();
        setSearchValue('');
        onFinish(values);
      })
      .catch(info => {
        console.info('Validate failed: ', info);
      });
  };

  return (
    <>
      <Button type='primary' onClick={showModal} ref={ref}>
        Сгенерировать ID
      </Button>
      <Modal
        title='Добавление нового устройства'
        open={isGenerateIdOpen}
        onCancel={handleCancel}
        footer={[
          <Button key='back' onClick={handleCancel}>
            Отмена
          </Button>,
          <Button key='submit' type='primary' onClick={handleOk} disabled={!isFormValid}>
            OK
          </Button>,
        ]}
      >
        <Form
          name='basic'
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          initialValues={{ remember: true }}
          form={form}
          autoComplete='off'
          onValuesChange={checkFormValidity}
        >
          <Form.Item
            label='Android ID'
            name='device_id'
            initialValue={searchValue}
            rules={[{ required: true, message: 'Необходимо указать ID устройства!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label='Позывной'
            name='call_sign'
            rules={[{ required: true, message: 'Необходимо указать позывной!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label='Военная часть'
            name='army_post'
            rules={[{ required: true, message: 'Необходимо указать военную часть!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label='Тип устройства'
            name='type'
            rules={[{ required: true, message: 'Необходимо указать тип устройства!' }]}
          >
            <Select labelInValue options={DEVICE_OPTIONS} />
          </Form.Item>
          <Form.Item label='Пользователь' name='sub_id' onClick={fetchUserData}>
            <Select
              showSearch
              mode='multiple'
              placeholder='Выберите пользователя'
              optionFilterProp='children'
              value={value}
              filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              options={data?.map(({ id, name, email }) => ({ value: id, label: name || email }))}
              onChange={newValue => setValue(newValue)}
            />
          </Form.Item>
          <Form.Item label='Телефон/Telegram' name='tg'>
            <Input />
          </Form.Item>
          <Form.Item label='Серия' name='serial'>
            <Input />
          </Form.Item>
          <Form.Item label='Лицензия истекает:' name='license_expires' initialValue={nextYearDate}>
            <DatePicker />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default GenerateNewIdModal;
